const isBrowser = typeof window !== 'undefined'

const isLocalHost = () => {
  if (!isBrowser) return false
  const host = window.location.hostname.toLowerCase()
  return host === 'localhost' || host === '127.0.0.1'
}

const isStgHost = () => {
  if (!isBrowser) return false
  const host = window.location.hostname.toLowerCase()
  return host.includes('stg')
}

const isStgEnv = () => {
  const raw = String(process.env.REACT_APP_ENV || process.env.NODE_ENV || '').toLowerCase()
  return raw.includes('stg') || raw === 'development'
}

export const shouldLogMuteluApiDebug = () => {
  if (process.env.REACT_APP_MUTELU_DEBUG_LOG === 'true') return true
  return isLocalHost() || isStgHost() || isStgEnv()
}

const shouldVerboseRequestLog = () => {
  if (!isBrowser) return false
  if (!isLocalHost()) return false
  return localStorage.getItem('mutelu_debug_verbose_requests') === '1'
}

const buildTimestamp = () => new Date().toISOString()
const oncePerReloadRegistry = new Set()
const MAX_ONCE_KEYS = 500

const buildUserContext = () => {
  if (!isBrowser) {
    return {
      lineId: null,
      lineName: null,
      pagePath: null
    }
  }

  const lineId = localStorage.getItem('userId') || null
  const lineName = localStorage.getItem('line_display_name') || null
  const pagePath = `${window.location.pathname || ''}${window.location.search || ''}`

  return {
    lineId,
    lineName,
    pagePath
  }
}

const mergePayloadWithUserContext = (payload) => {
  const userContext = buildUserContext()
  if (payload == null) return userContext
  if (typeof payload === 'object' && !Array.isArray(payload)) {
    return {
      ...userContext,
      ...payload
    }
  }
  return {
    ...userContext,
    payload
  }
}

const buildOnceKey = (event, payloadWithContext) => {
  const pagePath = payloadWithContext?.pagePath || ''
  return `${event}::${pagePath}`
}

const shouldSkipBecauseAlreadyLogged = (event, payloadWithContext) => {
  const onceKey = buildOnceKey(event, payloadWithContext)
  if (oncePerReloadRegistry.has(onceKey)) return true
  oncePerReloadRegistry.add(onceKey)
  if (oncePerReloadRegistry.size > MAX_ONCE_KEYS) {
    oncePerReloadRegistry.clear()
    oncePerReloadRegistry.add(onceKey)
  }
  return false
}

const normalizeError = (error) => {
  if (!error) return null
  return {
    message: error?.message || 'unknown error',
    status: error?.status || error?.response?.status || null,
    data: error?.data || error?.response?.data || null
  }
}

const writeLog = (level, event, payload) => {
  if (!shouldLogMuteluApiDebug()) return
  const prefix = `[Mutelu][${buildTimestamp()}][${event}]`
  const payloadWithContext = mergePayloadWithUserContext(payload)
  if (shouldSkipBecauseAlreadyLogged(event, payloadWithContext)) return
  if (level === 'error') {
    console.error(prefix, payloadWithContext)
    return
  }
  if (level === 'warn') {
    console.warn(prefix, payloadWithContext)
    return
  }
  console.log(prefix, payloadWithContext)
}

export const logPageApiCall = (page, apiName, requestPayload = null) => {
  if (!shouldVerboseRequestLog()) return
  writeLog('log', `${page} -> ${apiName} request`, requestPayload)
}

export const logPageApiResult = (page, apiName, responsePayload = null) => {
  writeLog('log', `${page} <- ${apiName} response`, responsePayload)
}

export const logPageApiError = (page, apiName, error) => {
  writeLog('error', `${page} xx ${apiName} error`, normalizeError(error))
}

export const logMuteluPageView = (page, extraPayload = null) => {
  writeLog('log', `${page} :: page view`, extraPayload || {})
}
